import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';

@Injectable({ providedIn: 'root' })
export class OverviewService {
  constructor(private api: ApiService) {}

  /**
   * Get project overview details including total videos & documents
   * @param projectId MongoDB ObjectId of the project
   */
  getProjectOverview(projectId: string): Observable<any> {
    return this.api.get(`/projects/${projectId}`);
  }
}
